// ---------------------------------------------------------------------------
// SHUB-FE's settings for the shared hub-session transport (src/Util/hubSession.js,
// byte-identical across apps — configure it here, never edit it). Asana 1218458529003876.
// Imported second in src/index.js, right after hubSession.
//
// Who gets an ADMIN hub session: every logged-in SHUB-FE user. They are staff, and
// login is VT-Backend POST /agent/login (store/redux/User/actions.js signIn), which
// stores `jToken`. SHUB-FE never sets the extranet role keys the shared default reads
// ('extranet-vt-logged-in-role' / 'extranet-sh-logged-in-role') nor 'partnerLogin', so
// that default would give nobody a session. The jToken is exchanged per hub at
// POST <hub>/local/extranet/session/admin; the hub decides (approved VT-Backend agent).
// Sign-out (Sidebar / PageHeaderTopRow) runs localStorage.clear(), which drops the
// jToken and the stored hub sessions together.
// ---------------------------------------------------------------------------
import { configureHubSessions } from './hubSession'

configureHubSessions({ isAdminLogin: () => !!localStorage.getItem('jToken') })
